export const LOCATION_RESOURCE_NAME = 'location';

export const GET_LOCATION_REGION = 'GET_LOCATION_REGION';
export const GET_LOCATION_REGION_SUCCESS = 'GET_LOCATION_REGION_SUCCESS';
export const GET_LOCATION_REGION_FAILURE = 'GET_LOCATION_REGION_FAILURE';

export const locationRegionBackendPath = "/backend/common/location/region/";

export const getLocationRegion = (params, cancelPrevious = true) => ({
  type: GET_LOCATION_REGION,
  payload: {...params},
  meta: { httpMethod: 'GET', apiPath: locationRegionBackendPath, cancelPrevious},
});


// WEBPACK FOOTER //
// ./src/actions/location/index.js